import { render, staticRenderFns } from "./m-material-relayout-modal.vue?vue&type=template&id=4ba2ff74&scoped=true&"
import script from "./m-material-relayout-modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-material-relayout-modal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-material-relayout-modal.vue?vue&type=style&index=0&id=4ba2ff74&prod&lang=less&scoped=true&"
import style1 from "./m-material-relayout-modal.vue?vue&type=style&index=1&id=4ba2ff74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2ff74",
  null
  
)

export default component.exports